<template>
  <v-layout row wrap>
    <v-snackbar
      v-model="snackbar"
      :bottom="y === 'bottom'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :timeout="timeout"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
    >
      Weight Goals updated!
      <v-btn
        color="secondary"
        flat
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
    <v-flex xs12 sm6>
      <div>
        <h4 class="headline mb-0">Units</h4>
        <div>Set your prefered units of measurement</div>
        <v-radio-group v-model="weightUnit" :mandatory="false">
          <v-radio color="secondary" label="kgs" value="kgs"></v-radio>
          <v-radio color="secondary" label="lbs" value="lbs"></v-radio>
        </v-radio-group>
      </div>
      <h4 class="headline mb-0">Set your weights</h4>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-text-field
          v-model.number="goals.starting_weight"
          :rules="rules"
          label="Starting Weight"
          required
          :suffix="weightUnit"
          type="number"
        ></v-text-field>
        <v-text-field
          v-model.number="goals.target_weight"
          :rules="rules"
          label="Target Weight"
          required
          :suffix="weightUnit"
          type="number"
        ></v-text-field>
        <v-btn
          color="primary"
          :disabled="!valid || loading"
          @click="submit"
          :loading:="loading"
        >
          submit
        </v-btn>
        <v-btn @click="clear">clear</v-btn>
      </v-form>
    </v-flex>
  </v-layout>
</template>
<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import { db } from '@/services/firebase'
export default {
  data: () => ({
    snackbar: false,
    y: 'top',
    x: null,
    mode: '',
    timeout: 6000,
    loading: false,
    date: moment().startOf('day').unix(),
    valid: true,
    rules: [
      v => !!v || 'Field is required',
      v => (v && !isNaN(v)) || 'Must be numerical'
    ],
    goals: {
      id: null,
      starting_weight: '',
      target_weight: ''
    },
    target: null,
    starting: null,
    weightUnit: ''
  }),
  mounted () {
    this.setWeightUnit()
  },
  watch: {
    weightUnit (val) {
      var localMeasureSystem = JSON.parse(localStorage.getItem('measureSystem'))
      localMeasureSystem.weight = this.weightUnit
      localStorage.setItem('measureSystem', JSON.stringify(localMeasureSystem))
      this.getGoals()
    }
  },
  methods: {
    setWeightUnit () {
      var system = JSON.parse(localStorage.getItem('measureSystem'))
      this.weightUnit = system.weight
      this.getGoals()
    },
    getGoals: function () {
      var self = this
      self.loading = true
      db.collection('user_goals').where('user_id', '==', self.currentUser)
        .get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            var data = doc.data()
            self.$set(data, 'id', doc.id)
            if (self.weightUnit === 'lbs') {
              var startingWeight = self.kgsToLbs(data.starting_weight)
              var targetWeight = self.kgsToLbs(data.target_weight)
              self.$set(data, 'starting_weight', startingWeight)
              self.$set(data, 'target_weight', targetWeight)
              self.goals = Object.assign({}, data)
            } else {
              self.$set(data, 'starting_weight', data.starting_weight)
              self.$set(data, 'target_weight', data.target_weight)
              self.goals = Object.assign({}, data)
            }
            self.loading = false
          })
        })
        .catch(function (error) {
          self.loading = false
          console.log('Error getting workouts: ', error)
        })
      self.loading = false
    },
    kgsToLbs (value) {
      if (value) {
        var lbs = (value * 2.205)
        var decimal = +lbs
        return decimal
      } else {
        return ''
      }
    },
    submit () {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.setStats()
      }
    },
    clear () {
      this.$refs.form.reset()
    },
    setStats: function () {
      var self = this
      var localMeasureSystem = JSON.parse(localStorage.getItem('measureSystem'))
      function lbsToKgs (value) {
        var kgs = (value / 2.205)
        return +kgs
      }
      var startingWeight = ''
      var targetWeight = ''
      targetWeight = self.goals.target_weight
      if (localMeasureSystem.weight === 'lbs') {
        startingWeight = lbsToKgs(self.goals.starting_weight)
        targetWeight = lbsToKgs(self.goals.target_weight)
      } else {
        startingWeight = self.goals.starting_weight
        targetWeight = self.goals.target_weight
      }
      if (self.goals.id) {
        var statRef = db.collection('user_goals').doc(self.goals.id)
        statRef.set({
          starting_weight: startingWeight,
          target_weight: targetWeight,
          user_id: self.currentUser
        }, { merge: true })
          .then(function () {
            self.loading = false
            self.snackbar = true
          })
          .catch(function (error) {
            self.loading = false
            console.error('Error', error)
          })
      } else {
        db.collection('user_goals').add({
          starting_weight: startingWeight,
          target_weight: targetWeight,
          user_id: self.currentUser
        })
          .then(function () {
            self.loading = false
            self.snackbar = true
          })
          .catch(function (error) {
            self.loading = false
            console.error('Error', error)
          })
      }
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      userProfile: 'userProfile'
    })
  }
}
</script>
<style scoped>
  .list {
    width: 100%;
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/members/addGoalsView.vue